import { useEffect, useMemo, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { listFiltersService } from "sprint-common-web";

import { AssetType } from "../../common/types/AssetType";

export interface AssetSearchPageFilters {
    query: string;
    types: number[];
}

const defaultFilters: AssetSearchPageFilters = {
    query: "",
    types: [AssetType.Cloud, AssetType.OnPrem]
};

export const useAssetSearchPageFilters = () => {
    const getDefaultFilters = (filters: AssetSearchPageFilters): AssetSearchPageFilters => {
        return { ...filters };
    };

    const generatedDefaultFilters = getDefaultFilters(defaultFilters);
    const filtersService = useMemo(() => listFiltersService<AssetSearchPageFilters>(generatedDefaultFilters), []);
    const location = useLocation();
    const history = useHistory();

    const [filters, setFilters] = useState<AssetSearchPageFilters>(() =>
        filtersService.getSavedFilters(location.search)
    );

    useEffect(() => {
        filtersService.saveFilters(location.pathname, history, filters);
    }, [location.pathname, history, filters]);

    const setQuery = (query: string): void => {
        if ((query.length === 0 || query.length > 2) && filters.query.trim() !== query.trim()) {
            changeFilters({ ...filters, query });
        }
    };

    const setTypes = (types: number[]): void => {
        setFilters((prevFilters: AssetSearchPageFilters) => ({ ...prevFilters, types }));
    };

    const clearFilters = () => {
        changeFilters(generatedDefaultFilters);
    };

    const changeFilters = (newFilters: AssetSearchPageFilters): void => {
        filtersService.saveFilters(location.pathname, history, newFilters);
        setFilters(newFilters);
    };

    return {
        filters,
        setTypes,
        setQuery,
        clearFilters
    };
};
